// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "85a319d7c5625fed4b6104a8e253f890" + ".css";
};